import React, { Fragment, useState, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { formBtn3 } from "../Utils/CustomClasses";
import { DeleteMultipleLeadAPI } from "../../API/Api";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

export default function DeleteMultipleLeads({ RowId,count,filterRecords,resetSelection }) {
     const [isOpen, setIsOpen] = useState(false)
     const cancelButtonRef = useRef(null)
     const UserDetails = useSelector((state) => state?.login?.userDetails);

     const toggle = () => {
        setIsOpen(!isOpen)
     }
     const onDelete = async () => {
        try {
            const payload = {
                leadIds: RowId
            };
            let response = await DeleteMultipleLeadAPI(payload); 
            if (response?.status == 200) {
                toast.success(response?.data?.data?.message)
                setIsOpen(false);
                filterRecords();
                resetSelection();
            } else {
                toast.error(response?.error);
            }
        } catch (err) {
            toast.error("Something went wrong");
            console.log('Error', err)
        }
     }
     return (
        <>
                {(UserDetails?.role?.roleName === "SuperAdmin" || 
                UserDetails?.role?.roleName === "Admin") && (
                        <button 
                        type="button" 
                        onClick={toggle} 
                        className={`${formBtn3} w-full text-center`}
                        >
                        Delete Leads
                        </button>
                )}
                <Transition.Root show={isOpen} as={Fragment}>
                    <Dialog as="div" className="relative z-[100]" onClose={toggle}>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <div className="fixed inset-0 bg-black bg-opacity-25" />
                        </Transition.Child>
                        <div className="fixed inset-0 overflow-y-scroll">
                            <div className="flex items-center justify-center min-h-full p-4 text-center">
                                <Transition.Child
                                    as={Fragment}
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 scale-95"
                                    enterTo="opacity-100 scale-100"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 scale-100"
                                    leaveTo="opacity-0 scale-95"
                                >
                                    <Dialog.Panel className="w-full max-w-2xl overflow-hidden text-left align-middle transition-all transform bg-white rounded-lg shadow-xl">
                                        <Dialog.Title
                                            as="h2"
                                            className="w-full px-3 py-4 text-lg font-semibold leading-6 text-white bg-base-color font-tb"
                                        >
                                            Delete Multiple Leads
                                        </Dialog.Title>
                                        <div className="p-4">
                                            <div className="flex items-center justify-center flex-col">
                                                <div>
                                                    <h4 className='text-black base-font-inter font-bold pt-2 capitalize w-[300px] text-center'>Are you sure ?</h4>
                                                </div>
                                                <div>
                                                    <h6>Do you really want to delete this <span className="font-bold text-black">{count} leads</span>. This process cannot be undone</h6>
                                                </div>
                                            </div>
                                        </div>
                                        <footer className="flex justify-end px-4 py-2 space-x-3 bg-white">
                                            <button
                                                type="button"
                                                onClick={onDelete}
                                                className={`${formBtn3} px-4 py-2 text-white font-bold rounded-lg`}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                type="button"
                                                className="w-auto lg:px-8 px-4 transition-colors font-tb tracking-wide duration-200 py-2.5 overflow-hidden text-base font-semibold text-center text-base-color border-2 border-base-color rounded-lg hover:text-white hover:bg-[var(--bg-base-color)] capitalize"
                                                onClick={() => setIsOpen(false)}
                                                ref={cancelButtonRef}
                                            >
                                                No
                                            </button>
                                        </footer>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </>
    )
    }